"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInfoInternal = getInfoInternal;
const chemical_elements_1 = require("chemical-elements");
const chemical_groups_1 = require("chemical-groups");
const Kind_1 = require("../Kind");
const getIsotopeRatioInfo_1 = require("./getIsotopeRatioInfo");
const getNumberOfIsotopologues_1 = require("./getNumberOfIsotopologues");
const partToAtoms_1 = require("./partToAtoms");
const partToMF_1 = require("./partToMF");
/** @typedef {import('./getInfo.types').MFInfo} MFInfo */
/** @typedef {import('./getInfo.types').MFInfoWithParts} MFInfoWithParts */
/**
 *
 * @param {*} parts
 * @param {*} [options={}]
 * @returns {object|MFInfo|MFInfoWithParts}
 */
function getInfoInternal(parts, options = {}) {
    let { customUnsaturations = {}, emFieldName = 'monoisotopicMass', msemFieldName = 'observedMonoisotopicMass', } = options;
    if (parts.length === 0)
        return {};
    if (parts.length === 1) {
        let oneResult = getProcessedPart(parts[0], {
            customUnsaturations,
            emFieldName,
            msemFieldName,
        });
        oneResult.nbIsotopologues = (0, getNumberOfIsotopologues_1.getNumberOfIsotopologues)(oneResult.atoms);
        return oneResult;
    }
    let result = { parts: [] };
    for (let part of parts) {
        result.parts.push(getProcessedPart(part, {
            customUnsaturations,
            emFieldName,
            msemFieldName,
        }));
    }
    result[emFieldName] = 0;
    result.mass = 0;
    result.charge = 0;
    result.unsaturation = 0;
    result.atoms = {};
    result.mf = result.parts.map((a) => a.mf).join('.');
    for (const part of result.parts) {
        result.mass += part.mass;
        result[emFieldName] += part[emFieldName];
        result.charge += part.charge;
        result.unsaturation += part.unsaturation;
        for (const atom in part.atoms) {
            if (!result.atoms[atom]) {
                result.atoms[atom] = 0;
            }
            result.atoms[atom] += part.atoms[atom];
        }
    }
    result.nbIsotopologues = (0, getNumberOfIsotopologues_1.getNumberOfIsotopologues)(result.atoms);
    return result;
}
function getProcessedPart(part, options) {
    let { customUnsaturations, emFieldName, msemFieldName } = options;
    /** @type {MFInfo} */
    let currentPart = {
        mass: 0,
        charge: 0,
        mf: '',
        atoms: (0, partToAtoms_1.partToAtoms)(part),
        [emFieldName]: 0,
    };
    let unsaturation = 0;
    let validUnsaturation = true;
    currentPart.mf = (0, partToMF_1.partToMF)(part);
    for (let line of part) {
        let currentElement = '';
        switch (line.kind) {
            case Kind_1.Kind.ATOM: {
                currentElement = line.value;
                let element = chemical_elements_1.elementsAndIsotopesObject[line.value];
                // todo should we have a kind GROUP ?
                if (!element) {
                    element = chemical_groups_1.groupsObject[line.value];
                    if (!element)
                        throw new Error(`Unknown element: ${line.value}`);
                    if (!customUnsaturations[line.value]) {
                        customUnsaturations[line.value] = element.unsaturation;
                    }
                }
                if (!element)
                    throw new Error(`Unknown element: ${line.value}`);
                currentPart[emFieldName] += element.monoisotopicMass * line.multiplier;
                currentPart.mass += element.mass * line.multiplier;
                break;
            }
            case Kind_1.Kind.ISOTOPE: {
                currentElement = line.value.atom;
                let isotope = chemical_elements_1.isotopesObject[line.value.isotope + line.value.atom];
                if (!isotope) {
                    throw new Error(`Unknown isotope: ${line.value.isotope}${line.value.atom}`);
                }
                currentPart[emFieldName] += isotope.mass * line.multiplier;
                currentPart.mass += isotope.mass * line.multiplier;
                break;
            }
            case Kind_1.Kind.ISOTOPE_RATIO: {
                currentElement = line.value.atom;
                let isotopeRatioInfo = (0, getIsotopeRatioInfo_1.getIsotopeRatioInfo)(line.value);
                currentPart[emFieldName] +=
                    isotopeRatioInfo[emFieldName] * line.multiplier;
                currentPart.mass += isotopeRatioInfo.mass * line.multiplier;
                break;
            }
            case Kind_1.Kind.CHARGE:
                currentPart.charge = line.value;
                if (validUnsaturation) {
                    unsaturation -= line.value;
                }
                break;
            default:
                throw new Error('Unimplemented Kind in getInfo', line.kind);
        }
        if (currentElement) {
            if (customUnsaturations[currentElement] !== undefined) {
                unsaturation += customUnsaturations[currentElement] * line.multiplier;
            }
            else if (chemical_elements_1.unsaturationsObject[currentElement] !== undefined) {
                unsaturation += chemical_elements_1.unsaturationsObject[currentElement] * line.multiplier;
            }
            else {
                validUnsaturation = false;
            }
        }
    }
    // need to calculate the observedMonoisotopicMass
    if (currentPart.charge) {
        currentPart[msemFieldName] =
            (currentPart[emFieldName] - currentPart.charge * chemical_elements_1.ELECTRON_MASS) /
                Math.abs(currentPart.charge);
    }
    if (validUnsaturation) {
        currentPart.unsaturation = unsaturation / 2 + 1;
    }
    return currentPart;
}
//# sourceMappingURL=getInfoInternal.js.map